import BasicButton from "@/components/core/buttons/BasicButton";
import { Right } from "@/type/core/offices/offices.types";
import { TransactionDetail } from "@/type/core/transaction/transaction.types";
import { FunctionComponent } from "react";

interface TransactionFinalizeButtonProps {
  transaction: TransactionDetail;
  onClick: () => void;
  officeRights?: Right[];
  signatureRight: Right;
  label: string;
  disabled?: boolean;
  className?: string;
}

const TransactionFinalizeButton: FunctionComponent<
  TransactionFinalizeButtonProps
> = ({
  transaction,
  onClick,
  officeRights,
  signatureRight,
  label,
  disabled = false,
  className,
}) => {
  if (
    transaction.type === "signature" &&
    officeRights?.includes(signatureRight) &&
    transaction.universignVersion === "U2" &&
    transaction.signatories?.some((signatory) => signatory.status === "signed")
  ) {
    return (
      <BasicButton
        disabled={disabled}
        variant="tertiary"
        text={label}
        onClick={onClick}
        className={`py-11 px-30 font-extra-small ${className}`}
      />
    );
  }

  return null;
};

export default TransactionFinalizeButton;
